'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EmbeddedChatWidget = require('./components/EmbeddedChatWidget.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_EmbeddedChatWidget).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-embedded-chat-widget/lib/index.js
// module id = 1481
// module chunks = 1